import { useThemeContext } from '@/entities/theme/lib/context'
import { NavLink } from 'react-router-dom'
import { PayxIcon } from './PayxIcon'
import { SyncraIcon } from './SyncraIcon'
import { YellowpayIcon } from './YellowpayIcon'
import { useDomainType } from '@/entities/domain/hooks/useDomainType'

interface MainIconProps {
  width?: number
  height?: number
}

export const MainIcon = (props: MainIconProps) => {
  const { theme } = useThemeContext()
  const isDark = theme === 'dark'
  const domainType = useDomainType()

  const defaultDimensions =
    domainType === 'payx' ? { width: 160, height: 38 } :
    domainType === 'yellowpay' ? { width: 165, height: 34 } :
    { width: 145, height: 40 }

  const { width = defaultDimensions.width, height = defaultDimensions.height } = props

  return (
    <NavLink to="/dashboard">
      {domainType === 'payx' ? (
        <PayxIcon width={width} height={height} isDark={isDark} />
      ) : domainType === 'yellowpay' ? (
        <YellowpayIcon width={width} height={height} isDark={isDark} />
      ) : (
        <SyncraIcon width={width} height={height} isDark={isDark} />
      )}
    </NavLink>
  )
}

export default MainIcon
